import {
  getPropDefaultsBase
} from "./chunk-76FQY6HX.js";
import {
  typographyStyles
} from "./chunk-BU6N4DJ3.js";
import {
  select
} from "./chunk-YMNSXZ5D.js";
import {
  applyTypography
} from "./chunk-XBZNPA3L.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/base/Headline.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
var headlineElements = ["h1", "h2", "h3", "h4", "h5", "h6"];
function HeadlineString(props) {
  const _a = getPropDefaults(props), { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ jsx(StyledHeadline, __spreadProps(__spreadValues({}, rest), { children }));
}
function getPropDefaults(props) {
  return getPropDefaultsBase(props, { as: props.heading || "h1" });
}
var StyledHeadline = styled.span`
  ${({ theme, size, colorProp }) => applyTypography(theme, "Headline", size, colorProp)}
  ${typographyStyles}
`;
function headlineSelector(heading) {
  return `${heading}${select(StyledHeadline)}`;
}
var ALL_HEADLINE_SELECTORS = headlineElements.map(headlineSelector).join(",");

export {
  headlineElements,
  HeadlineString,
  getPropDefaults,
  StyledHeadline,
  headlineSelector,
  ALL_HEADLINE_SELECTORS
};
